const initBlock = function( $block ) {
	const $processSteps = $block.find( '.process-step' );
	if ( !$processSteps.length ) { return false; }

	function setupProcessSteps() {
		const isTouchDevice = 'ontouchstart' in window || window.innerWidth < 1024;
		const $processSteps = $block.find( '.process-step' );

		if ( !$processSteps.length ) {return;}

		$processSteps.off( 'mouseenter mouseleave click' );

		$processSteps.each( function() {
			const $step = $( this );
			const $overlay = $step.find( '.process-step__bg-overlay' );
			const $content = $step.find( '.process-step__hidden' );

			if ( isTouchDevice ) {
				$step.on( 'click', function( e ) {
					e.stopPropagation();
					const isOpen = $step.hasClass( 'is-expanded' );

					$processSteps.not( $step ).removeClass( 'is-expanded' )
						.find( '.process-step__bg-overlay' ).fadeOut( 350 ).end()
						.find( '.process-step__hidden' ).slideUp( 350 );

					if ( !isOpen ) {
						$overlay.stop( true, false ).fadeIn( 350 );
						$content.stop( true, false ).slideDown( 350 );
						$step.addClass( 'is-expanded' );
					} else {
						$overlay.stop( true, false ).fadeOut( 350 );
						$content.stop( true, false ).slideUp( 350 );
						$step.removeClass( 'is-expanded' );
					}
				} );
			} else {
				$step.on( 'mouseenter', function() {
					$overlay.stop( true, false ).fadeIn( 350 );
					$content.stop( true, false ).slideDown( 350 );
				} );
				$step.on( 'mouseleave', function() {
					$overlay.stop( true, false ).fadeOut( 350 );
					$content.stop( true, false ).slideUp( 350 );
				} );
			}
		} );
	}

	setupProcessSteps();

	let resizeTimer = false;
	$( window ).on( 'resize', function() {
		clearTimeout( resizeTimer );
		resizeTimer = setTimeout( setupProcessSteps, 300 );
	} );
};

app.loadBlock( initBlock, 'section-process', '.section-process' );

if ( module.hot ) {
	module.hot.accept();
}
